<div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
  <div>
    <i class="fa-solid fa-home session-header-icon"></i>
    <span class="session-header-title">Session Options</span>
  </div>
  <button type="button" class="close-button" aria-label="Close" (click)="closeModal()">×</button>
</div>
<div class="modal-body text-center">
  <div class="row justify-content-center">
    <div class="col-4">
      <div class="card mode-card" (click)="selectMode(monitorModeName)">
        <div class="mx-auto mb-2">
          <span class="mode-icon-circle mode-icon-monitor">
            <i class="fa-solid fa-tv mode-icon"></i>
          </span>
        </div>
        <div>{{monitorModeName}}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="card mode-card" (click)="selectMode(liveModeName)">
        <div class="mx-auto mb-2">
          <span class="mode-icon-circle mode-icon-live">
            <i class="fa-solid fa-satellite-dish mode-icon"></i>
          </span>
        </div>
        <div>{{liveModeName}}</div>
      </div>
    </div>
    <div class="col-4">
      <div class="card mode-card" (click)="selectMode(playbackModeName)">
        <div class="mx-auto mb-2">
          <span class="mode-icon-circle mode-icon-playback">
            <i class="fa-solid fa-repeat mode-icon"></i>
          </span>
        </div>
        <div>{{playbackModeName}}</div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cancel</button>
</div>